import { ON_SIGN_IN_REDIRECT_URL } from '@config/endpoints'
import { useCart } from '@lib/hooks/use-cart'
import { useRouter } from 'next/router'
import * as qs from 'query-string'
import { useMemo } from 'react'

export function useSignInRedirectUrl() {
  const router = useRouter()
  const { cart } = useCart()
  const cartId = cart?.id

  return useMemo(() => {
    const query = { ...router.query, cart_id: cartId }
    return `${ON_SIGN_IN_REDIRECT_URL}?${qs.stringify(query)}`
  }, [router.query, cartId])
}
